<template>
  <v-container fluid>
    <material-card icon="mdi-image" inline title="Photos">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-row>
        <v-col cols="12" sm="6" lg="4" v-for="photo in photos" :key="photo.id">
          <v-card outlined class="mx-auto" max-width="400">
            <v-img v-if="photo.type === 'IMAGE'" :src="photo.urlPath"></v-img>
            <div v-if="photo.type === 'IMAGE_LINK'" @click="download(photo.urlPath)"
              style="cursor: pointer;margin-left: 10px;margin-top: 5px;"
              class="tag is-primary caption">
              Photo Link
            </div>
            <div v-if="photo.type === 'VIDEO'" @click="download(photo.urlPath)"
              style="cursor: pointer;margin-left: 10px;margin-top: 5px;"
              class="tag is-primary caption">
              Video Link
            </div>
            <v-card-actions class="px-4">
              <span class="caption" v-text="photo.Date"></span>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
// import Utils from '@/utils'
export default {
  name: 'photogallaryViewImages',
  components: {
    MaterialCard
  },
  props: ['ID'],
  data () {
    return {
      photos: [],
      isLoading: false
    }
  },
  async created () {
    await this.Save()
  },

  methods: {
    async Save () {
      this.isLoading = true
      try {
        let photos = []
        const { data } = await http.get(`${constants.API_URL}/api/communication/photo-gallery/${this.ID}`)
        data.photoGalleryDocumentMaps.forEach((e) => {
          if (e.isActive === true) {
            if (e.type === 'IMAGE' && e.isLink === true) {
              photos.push({
                Date: moment(e.createdAt, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                urlPath: e.urlPath,
                type: 'IMAGE_LINK'
              })
            } else {
              photos.push({
                Date: moment(e.createdAt, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                urlPath: e.urlPath,
                type: e.type
              })
            }
            this.photos = photos
          }
        })
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error while getting images', errorMessage)
      }
    },
    download: async function (url) {
      try {
        window.open(url)
      } catch (e) {
        this.errMsg(`Error While getting file details, ${e}`)
      }
    }
  }
}
</script>
